import {as_memoPopupMessage, as_memoPopupOpen, as_memory, MemoItem} from "./app";
import * as Cookies from 'es-cookie';
import $ from 'jquery';
import {getActivitiyData} from "../js-memo/state";
import {as_serverSettings} from "../js-app/state";
import {getConnectedValue} from "./ConnectedStore";
import {as_activities} from "../js-backend/state";

//***************************************************************/
//* SAVING AND LOADED RELATED */
//***************************************************************/

function __loadMemoList(){
	var v:any = Cookies.get('neo-memo');
	if(!v) v = [];
	else v = JSON.parse(v);
	
	// console.log(`RESULT: `, v);
	//filter for invalid data
	
	v = v.filter((m)=>{
		return !!getActivitiyData(m);
	})
	as_memory.set(v as MemoItem[]);
}

function __saveCookie(){
	var d = as_memory.get();
	// console.log(`SAVING COOKIE: `,JSON.stringify(as_memory.get()));
	Cookies.set('neo-memo',JSON.stringify(as_memory.get()),{path:'/', expires:7});
}

export function clearMemoList(){
	as_memory.set([]);
	__saveCookie();
}
export function removeFromMemoList(el:MemoItem){
	as_memory.remove(el);
	__saveCookie();
}
export function addToMemoList(el:MemoItem){
	if(!el.wpID) delete el.wpID;
	if(!el.bookingID) delete el.bookingID;
	// console.log(`ADDING`);
	var existingElement = as_memory.get().find((e)=>{
		if(el.wpID && e.wpID == el.wpID) return true;
		if(el.bookingID && e.bookingID == el.bookingID) return true;
		return false;
	});
	
	if(!existingElement){
		as_memory.push(el);
		as_memoPopupMessage.set('Hinzugefügt');
		__saveCookie();
	}
}

//***************************************************************/
//* SHORTCODES */
//***************************************************************/
declare var NeoData: any;
export function initMemoList(){
	__loadMemoList();
	__saveCookie(); //to refresh duration of cookie
    var validActivities = NeoData.data.activities;
    
    $('.neo-memo-add-btn').each((idx,e)=>{
		var wpid:any = /neo-wp-id-(\d*)/.exec(e.className);
		var bid:any = /neo-booking-id-(\d*)/.exec(e.className);
		if(bid) bid = parseInt(bid[1]);
		if(wpid) {
            wpid = parseInt(wpid[1]);
        }
        var isValid = validActivities.find((act)=>{
            if(act.id == wpid) return true;
            return !!act?.variants[bid];
        })
	    //if we are using old_id we can compare it and change the id
	    if(wpid && !isValid){
		    const changeAct = validActivities.find((act)=>{
			    return act.old_id == wpid;
		    });
		    // console.log(`TESTING FOR OLD IDs `, changeAct);
		    if(changeAct){
			    isValid = true;
			    // console.log(`Changed old ID ${wpid} to ${changeAct.id}`);
			    $(e).removeClass('neo-wp-id-'+wpid)
			    $(e).addClass('neo-wp-id-'+changeAct.id)
		    }
	    }
        if(!isValid) {
            // console.log(`Removed Neo Button "${e.textContent}" because the IDs(wp: ${wpid} booking:${bid}) are not recognized (or the activities already deactivated).`);
            e.remove();
        }
    })
	$('.neo-memo-add-btn').on('click',(e)=>{
		var bid:any = /neo-booking-id-(\d*)/.exec(e.currentTarget.className);
		var wpid:any = /neo-wp-id-(\d*)/.exec(e.currentTarget.className);
		if(bid) bid = parseInt(bid[1]);
		if(wpid) wpid = parseInt(wpid[1]);
		var addEl:MemoItem = {bookingID:bid, wpID:wpid};
		addToMemoList(addEl);
		e.preventDefault();
		e.stopPropagation();
		e.stopImmediatePropagation();
	});
}